import { render, staticRenderFns } from "./locale-switcher.vue?vue&type=template&id=3d525ac6&scoped=true&"
import script from "./locale-switcher.vue?vue&type=script&lang=js&"
export * from "./locale-switcher.vue?vue&type=script&lang=js&"
import style0 from "./locale-switcher.vue?vue&type=style&index=0&id=3d525ac6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d525ac6",
  null
  
)

export default component.exports